import { render } from "./ShareButtons.vue?vue&type=template&id=b47fd87e"
import script from "./ShareButtons.vue?vue&type=script&lang=js"
export * from "./ShareButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__